<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('')"
  >
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <form #form="ngForm">
    <div class="onboarding-content form-group">
      <label for="">email</label>
      <div class="input-group">
        <input
          class="form-control"
          [(ngModel)]="email"
          name="email"
          #emailModel="ngModel"
          required
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
          placeholder="Enter your email"
          type="text"
        />
      </div>
      <div *ngIf="emailModel.invalid && emailModel.touched" class="text-danger">
        <div *ngIf="emailModel.errors?.required">Email is required.</div>
        <div *ngIf="emailModel.errors?.pattern">Invalid email format.</div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Abbrechen</button>
  <button type="button" ngbAutofocus class="btn btn-secondary" (click)="onConfirm()">{{ buttonText }}</button>
</div>
